@if (isLoggedIn()) {
    <div class="relative">
        <button
            type="button"
            (click)="toggleDropDown()"
            aria-label="Open profile menu"
            class="flex cursor-pointer items-center gap-2.5 rounded-lg p-1 transition-colors hover:bg-gray-100"
        >
            <!-- Fully rounded 2-letter avatar -->
            <div
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#1587e8] text-sm font-semibold text-white shadow-sm"
            >
                {{ displayInitials() }}
            </div>
            <div class="hidden flex-col items-start leading-tight sm:flex">
                <span class="text-sm font-semibold text-gray-800">
                    {{ displayName() }}
                </span>
                <span class="text-xs text-gray-400 capitalize">
                    {{ displayRole() }}
                </span>
            </div>
            <ng-icon
                name="lucideChevronDown"
                class="hidden h-4 w-4 text-gray-400 sm:block"
            />
        </button>

        @if (isVisibleDropDown()) {
            <div
                class="absolute top-12 right-0 z-50 flex w-56 origin-top-right flex-col rounded-xl border border-gray-200 bg-white py-2 shadow-xl shadow-gray-200/60"
            >
                <!-- User Profile Header -->
                <div class="border-b border-gray-100 px-4 pt-2 pb-3">
                    <p class="truncate text-sm font-semibold text-gray-800">
                        {{ displayName() }}
                    </p>
                    @if (displayEmail()) {
                        <p class="truncate text-xs text-gray-400">
                            {{ displayEmail() }}
                        </p>
                    }
                    <span
                        class="mt-1 inline-block rounded bg-blue-50 px-1.5 py-0.5 text-[10px] font-medium text-blue-700 capitalize"
                    >
                        {{ displayRole() }}
                    </span>
                </div>

                <!-- Role Specific Navigation Links -->
                @if (displayRole() === 'Admin') {
                    <a
                        routerLink="/admin/settings"
                        (click)="closeDropDown()"
                        class="mt-1.5 flex items-center gap-2 px-4 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-50"
                    >
                        <ng-icon name="lucideSettings" class="h-4 w-4" />
                        Settings
                    </a>
                } @else if (displayRole() === 'Vendor') {
                    <a
                        routerLink="/vendor/company-profile"
                        (click)="closeDropDown()"
                        class="mt-1.5 flex items-center gap-2 px-4 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-50"
                    >
                        <ng-icon name="lucideBuilding2" class="h-4 w-4" />
                        Company Profile
                    </a>
                    <a
                        routerLink="/vendor/settings"
                        (click)="closeDropDown()"
                        class="flex items-center gap-2 px-4 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-50"
                    >
                        <ng-icon name="lucideSettings" class="h-4 w-4" />
                        Settings
                    </a>
                } @else {
                    @if (showClientDashboard()) {
                        <a
                            routerLink="/client/dashboard"
                            (click)="closeDropDown()"
                            class="mt-1.5 flex items-center gap-2 px-4 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-50"
                        >
                            <ng-icon
                                name="lucideLayoutDashboard"
                                class="h-4 w-4"
                            />
                            Dashboard
                        </a>
                    }
                    <a
                        routerLink="/client/profile"
                        (click)="closeDropDown()"
                        class="flex items-center gap-2 px-4 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-50"
                        [class.mt-1.5]="!showClientDashboard()"
                    >
                        <ng-icon name="lucideUser" class="h-4 w-4" />
                        My Profile
                    </a>
                    <a
                        routerLink="/client/claimed-items"
                        (click)="closeDropDown()"
                        class="flex items-center gap-2 px-4 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-50"
                    >
                        <ng-icon name="lucideShoppingCart" class="h-4 w-4" />
                        My Items
                    </a>
                }

                <!-- Extra Custom Menu Items slot -->
                <ng-content select="[custom-menu-items]" />

                <div class="my-1 border-t border-gray-100"></div>

                <!-- Log Out Button -->
                <button
                    type="button"
                    (click)="logout()"
                    class="flex items-center gap-2 px-4 py-2 text-left text-sm text-red-600 transition-colors hover:bg-red-50"
                >
                    <ng-icon name="lucideLogOut" class="h-4 w-4" />
                    Log Out
                </button>
            </div>
        }
    </div>
} @else {
    <a
        routerLink="/login"
        class="flex items-center gap-2 rounded-lg bg-[#1587e8] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#1172c7]"
    >
        <ng-icon name="lucideUser" class="h-4 w-4" />
        <span>Sign In</span>
    </a>
}
